import { render } from "./FilterContractComponent.vue?vue&type=template&id=ddbb0688"
import script from "./FilterContractComponent.vue?vue&type=script&lang=js"
export * from "./FilterContractComponent.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__